module.exports = __webpack_public_path__ + "static/media/11+.22f26ed0.svg";